<template lang="html">
  <div class="related-content">
    <RelatedContentTile
      v-for="item in randomItems"
      :key="item.id"
      :background="
        item.columns.teaser
          ? item.columns.teaser.media && item.columns.teaser.media.path
          : item.columns.media && item.columns.media.path"
    >
      <div
        v-if="item.columns.subline"
        v-html="item.columns.subline"
      />
      <nuxt-link v-if="getUrl(item)" :to="getUrl(item)">
        <Headline color="white">
          <span
            v-html="item.columns.title"
          />
        </Headline>
      </nuxt-link>
    </RelatedContentTile>
  </div>
</template>

<script>
import { Resource } from 'beisheim/models'
import { sampleSize } from 'lodash'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Headline from 'beisheim/components/elements/headline'
import RelatedContentTile from 'beisheim/components/elements/related-content-tile'

export default {
  components: {
    Headline,
    RelatedContentTile
  },
  mixins: [ editable ],
  computed: {
    randomItems () {
      return sampleSize(this.resource.children, 2)
    }
  },
  methods: {
    getUrl (item) {
      return item.url || Resource.find(item.columns.link_name).url
    }
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/grid';
@import '~beisheim/scss/breakpoints';

$component: '.related-content';

#{$component} {
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  @include from(4) {
    flex-direction: row;
  }
}
</style>
